import React from "react";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) {
  const isAuth = localStorage.getItem("user") || localStorage.getItem("token");
  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default PrivateRoute;
